import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo, useMemo } from 'react';
import { DoubleSide } from 'three';
import { IFontTypes, ITextAlignment } from '../component-data-structure';
import CurvedEntity from './CurvedEntity/CurvedEntity';
const TextComp = ({ scale: s, color, text, fontFamily = IFontTypes.Roboto400, fontSize = 2, fontRgba, position, rotation, textAlignment = ITextAlignment.left, onPointerUp, onPointerMove, onPointerDown, onDoubleClick, onPointerOut, onPointerOver, renderOrder, curvature, id = '', raycast, castShadow = false, receiveShadow = false, animationTransformGroupPrefix = '', side }) => {
    const scale = useMemo(() => s, [s]);
    const zeroPos = useMemo(() => [0, 0, 0], []);
    const userData = useMemo(() => ({ renderOrder, contentId: id }), [id, renderOrder]);
    return (_jsx("group", { userData: userData, name: `${animationTransformGroupPrefix}${id}`, raycast: raycast, position: position, rotation: rotation, onPointerUp: onPointerUp || undefined, onPointerDown: onPointerDown || undefined, onPointerMove: onPointerMove || undefined, onDoubleClick: onDoubleClick || undefined, onPointerOver: e => {
            onPointerOver?.(e);
            // console.log('text', e);
        }, onPointerOut: onPointerOut || undefined, children: _jsx("group", { name: `${animationTransformGroupPrefix}inner_${id}`, children: _jsx(CurvedEntity, { raycast: raycast, scale: scale, cornerRadius: 0, position: zeroPos, renderOrder: renderOrder, opacity: color[3], curvature: curvature, side: side ?? DoubleSide, colorRgba: color, castShadow: castShadow, receiveShadow: receiveShadow, text: {
                    value: text,
                    side: side ?? DoubleSide,
                    textAlignment,
                    fontSize,
                    fontFamily,
                    fontRgba: fontRgba,
                    preventPolygonOffset: true
                } }, id) }) }, 'btn_group'));
};
export default memo(TextComp);
